import React from "react";
import classes from "../../style/HomeScreen.module.css";
import "../../style/Welcomescreens.scss";
import { useNavigate } from "react-router-dom";
import { Dexter_Splash3, ROUTE_MOBILE_VERIFICATION } from "../../Routes";
import NewDexterLogo from "../../Images/NewDexterLogo.svg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const SecondSplash = () => {
  const Navigate = useNavigate();

  const HandleSubmit = () => {
    // const params = '?ex=true';
    // Navigate(`${Dexter_Splash3}${params}`);
    Navigate(ROUTE_MOBILE_VERIFICATION)
  };

  return (
    <div className="Splash2_Main_Container">
      <header className="Splash1Header">
        <img alt="" src={NewDexterLogo} className="DexterLogo"/>
      </header>
      <div className="Internal_Main_Container2">
        <span className="Splash2Heading1">Dexterr Explains </span>
        <span className="Splash2SubHeading">
          Audio Guide on every Page. Just click on Dexterr Explains on the top
          right section of the page and let Dexterr make it easier for you.{" "}
        </span>

        <div className="Spash2_Button_Container">
          <button className="SplashButton" onClick={HandleSubmit}>
            Continue{" "}
            <KeyboardArrowRightIcon className={classes.RightButtonArrow} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SecondSplash;
